import React from 'react';
import { AreaChart, Area, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const ChartComponent = ({ type, data, title, dataKey1, dataKey2, label1, label2, color1, color2 }) => {
  const formatCurrency = (value) => {
    if (isNaN(value)) return '$0.00';
    return `$${value.toLocaleString('es-ES', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow border">
      <h3 className="text-lg font-semibold text-gray-800 mb-4">{title}</h3>
      <ResponsiveContainer width="100%" height={300}>
        {type === 'area' ? (
          <AreaChart
            data={data}
            margin={{ top: 10, right: 30, left: 20, bottom: 10 }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" stroke="#888" />
            <YAxis tickFormatter={formatCurrency} stroke="#888" />
            <Tooltip formatter={formatCurrency} />
            <Legend />
            <Area
              type="monotone"
              dataKey={dataKey1}
              name={label1}
              stroke={color1}
              fill={color1}
              fillOpacity={0.3}
            />
            {dataKey2 && (
              <Area
                type="monotone"
                dataKey={dataKey2}
                name={label2}
                stroke={color2}
                fill={color2}
                fillOpacity={0.3}
              />
            )}
          </AreaChart>
        ) : (
          <BarChart
            data={data}
            margin={{ top: 10, right: 30, left: 20, bottom: 10 }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" stroke="#888" />
            <YAxis tickFormatter={formatCurrency} stroke="#888" />
            <Tooltip formatter={formatCurrency} />
            <Legend />
            <Bar dataKey={dataKey1} name={label1} fill={color1} />
          </BarChart>
        )}
      </ResponsiveContainer>
    </div>
  );
};

export default ChartComponent;